import * as React from 'react';
import { SVGProps } from 'react';

const IconNodeStartSizeM = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M2 6a1 1 0 0 1 1-1h17a1 1 0 0 1 1 1v2a4 4 0 0 0 0 8v2a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V6z" />
    <path d="M21 14a2 2 0 1 0 0-4 2 2 0 0 0 0 4z" />
  </svg>
);
export default IconNodeStartSizeM;
